import { observer } from 'mobx-react-lite';
import { getCommandCategories, getCommands } from 'owa-calendar-hotkeys';
import { isBoardViewTypeSelected } from 'owa-calendar-module-store';
import { HotkeysMap } from 'owa-hotkeys-map';
import * as React from 'react';
import { lazyMountAndShowFullOptions } from 'owa-options-view';
import { isFeatureEnabled } from 'owa-feature-flags';
import shouldUseMonarchShortcuts from 'owa-hotkeys/lib/utils/shouldUseMonarchShortcuts';

export default observer(function CalendarModuleHotkeysMap() {
    const categories = getCommandCategories(isBoardViewTypeSelected());
    const commands = Object.values(getCommands());
    const firstColumnLength =
        (isFeatureEnabled('cal-web-hotkeys') || shouldUseMonarchShortcuts()) &&
        !isBoardViewTypeSelected()
            ? 1
            : 2;

    return (
        <HotkeysMap
            commandCategories={categories}
            goToOptions={goToOptions}
            hotkeyCommands={commands}
            firstColumnLength={firstColumnLength}
        />
    );
});

function goToOptions() {
    lazyMountAndShowFullOptions.importAndExecute('general', 'accessibility');
}
